import React from 'react';
import './TickerLogo.css';

/**
 * The company logo beside a ticker. One component, every surface.
 *
 * 2026-09-23. This markup was copy-pasted into three places (the desktop
 * portfolio row and two spots in the screener) and the CSS was defined twice,
 * at 18px in PortfolioTable.css and 20px in StockScreener.css. It had already
 * drifted, and the mobile portfolio card never got a logo at all because it is
 * a completely separate render path from the desktop table.
 *
 * That last part is the recurring one: the per-test breakdown (9/11) and the
 * overlay chart (9/12) were both desktop-only for the same reason. A shared
 * component is the fix that makes the next feature land on both.
 *
 * Crypto has no company logo, so callers pass isCrypto and get nothing rather
 * than a broken image. A logo that 404s hides itself, because a missing logo
 * should cost nothing visually.
 */
export default function TickerLogo({ symbol, isCrypto = false, size, className = '' }) {
  if (!symbol || isCrypto) return null;

  return (
    <img
      className={`ticker-logo ${className}`.trim()}
      src={`/api/public/logo/${symbol}`}
      alt=""
      loading="lazy"
      // Inline only when a caller needs a one-off size; everything else takes
      // the shared CSS so the sizes cannot drift apart again.
      style={size ? { width: size, height: size } : undefined}
      onError={(e) => { e.currentTarget.style.display = 'none'; }}
    />
  );
}
